import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { ProgressBarComponent } from '../progress-bar/progress-bar.component'
import { Kpi } from '@core/interfaces/kpis.interface'

@Component({
  selector: 'kpi-details',
  imports: [ProgressBarComponent],
  templateUrl: './kpi-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpiDetailsComponent {
  kpi = input.required<Kpi>()
  showProgressBar = input<boolean>(true)
}
